<template>
  <QCardSection class="p-0">
    <div class="flex items-center gap-8 p-24 pb-0">
      <q-icon
        size="1.25rem"
        color="primary-pure"
        name="svguse:#icon_phone"
      />
      <h3 class="text-headline-3 text-neutral-100">
        {{ t('caseContacts') }}
      </h3>
    </div>

    <template
      v-for="case_sucesso in alternativa.case_sucesso"
      :key="case_sucesso.id"
    >
      <q-list
        v-for="item in case_sucesso.contatocase_set"
        :key="item.id"
        class="w-full space-y-8 border-b border-neutral-100/10 px-24 py-16"
      >
        <q-card
          class="flex flex-col gap-4 bg-card-100 px-16 py-12 rounded-md border border-neutral-100/10 !shadow-none"
        >
          <p class="text-paragraph-3 text-neutral-100">
            {{ t('name') }}
          </p>
          <h3 class="text-headline-3 text-neutral-100">
            {{ item.nome }}
          </h3>
        </q-card>
        <q-card
          class="flex flex-col gap-4 bg-card-100 px-16 py-12 rounded-md border border-neutral-100/10 !shadow-none"
        >
          <p class="text-paragraph-3 text-neutral-100">
            {{ t('phone') }}
          </p>
          <h3 class="text-headline-3 text-neutral-100">
            {{ item.telefone }}
          </h3>
        </q-card>
        <q-card
          class="flex flex-col gap-4 bg-card-100 px-16 py-12 rounded-md border border-neutral-100/10 !shadow-none"
        >
          <p class="text-paragraph-3 text-neutral-100">
            {{ t('email') }}
          </p>
          <h3 class="text-headline-3 text-neutral-100">
            {{ item.email }}
          </h3>
        </q-card>
      </q-list>
    </template>
  </QCardSection>
</template>

<script setup>
import { useI18n } from 'vue-i18n'

const { t } = useI18n()

const props = defineProps({
  alternativa: Object,
})
</script>

<style lang="scss" scoped></style>
